"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'slotData.form.label': 'Etiqueta',
    'slotData.form.value': 'Valor',
    'slotData.form.type': 'Tipo',
};
